import React, { useCallback } from 'react';
import { Layout, RegularButton, Typography } from 'fronton-react';
import { AnalyticsPageMeta } from 'features/analytics';
import { useSelector } from 'react-redux';
import { getPathname } from 'features/page-model/ducks/get-model';
import { getIsAuthorized } from 'common/selectors';
import { useGaPageview } from 'features/analytics/hooks';
import { analyticsUtils, patchUrlByLocale } from 'utils';
import { useTranslation } from 'react-i18next';
import {
  errorDescription,
  errorHeading,
  ErrorPageWrapper,
  goHomeButton,
  paintImg,
  refreshButton,
} from './styles';
import { Error500Icon } from 'common/icons/error-500-icon';

export const Page500: React.FC = () => {
  const path = useSelector(getPathname);
  const isAuthorized = useSelector(getIsAuthorized) ? '1' : '0';
  const { t } = useTranslation();

  const sendGaEventBack = useCallback(() => {
    analyticsUtils.sendEvent(`GA:clickButton`, {
      elementType: 'button',
      elementBlock: 'landing500', // блок, в котором расположен элемент
      elementName: 'error500', // название блока (заголовок)
      elementText: 'Повторить', // заголовок пункта
    });
    location?.reload();
  }, []);

  const sendGaEventMain = useCallback(() => {
    analyticsUtils.sendEvent(`GA:clickButton`, {
      elementType: 'button',
      elementBlock: 'landing500', // блок, в котором расположен элемент
      elementName: 'error500', // название блока (заголовок)
      elementText: 'Перейти на главную', // заголовок пункта
    });
  }, []);

  useGaPageview(path, isAuthorized, null, 'other');

  return (
    <>
      <AnalyticsPageMeta
        manualTitle={t('500.meta.manualTitle')}
        manualDescription={t('500.meta.manualDescription')}
      />
      <Layout>
        <ErrorPageWrapper>
          <div className={paintImg}>
            <Error500Icon />
          </div>
          <Typography variant="h2" className={errorHeading}>
            {t('500.header')}
          </Typography>
          <Typography variant="m" size="body_long" className={errorDescription}>
            {t('500.description1')} <br />
            {t('500.description2')}
          </Typography>
          <RegularButton className={refreshButton} onClick={sendGaEventBack} variant="primary" size="l">
            {t('500.refresh')}
          </RegularButton>
          <RegularButton
            className={goHomeButton}
            onClick={sendGaEventMain}
            as="a"
            href={patchUrlByLocale('/')}
            variant="pseudo"
            size="l"
            rounded
            data-qa="to-main"
          >
            {t('500.redirect')}
          </RegularButton>
        </ErrorPageWrapper>
      </Layout>
    </>
  );
};
